import fetch from 'r/utils/fetch';

export default function fetchSanApi(body, _options = {}) {
  const options = {
    method: 'POST',
    body,
    ..._options,
  };
  if (import.meta.env.VITE_IS_LOCALHOST || import.meta.env.VITE_BACKEND_ENV_IS_PRODUCTION && import.meta.env.SAN_APIKEY) {
    options.headers = {
      Authorization: `Apikey ${import.meta.env.SAN_APIKEY}`,
    };
  }
  if (!import.meta.env.VITE_BACKEND_ENV_IS_PRODUCTION && import.meta.env.SAN_APIKEY_STAGE && !import.meta.env.VITE_IS_LOCALHOST) {
    options.headers = {
      Authorization: `Apikey ${import.meta.env.SAN_APIKEY_STAGE}`,
    };
  }
  return fetch(`https://api${!import.meta.env.VITE_BACKEND_ENV_IS_PRODUCTION && !import.meta.env.VITE_IS_LOCALHOST ? '' : ''}.santiment.net/graphql`, options);
}
